import { DayOfWeek } from './DateValues';
import {
    DaysInOneWeek,
    HoursInOneDay,
    MillisecondsIn1Hour,
    MillisecondsIn1Min,
    MillisecondsIn1Sec,
    MillisecondsIn30Mins,
    MillisecondsInOneDay,
    MinutesInOneDay,
    MinutesInOneHour,
    MonthInOneYear,
} from './constants';

/**
 * Common constants and methods
 */
const TimeConstants = {
    MillisecondsInOneDay,
    MillisecondsIn1Sec,
    MillisecondsIn1Min,
    MillisecondsIn30Mins,
    MillisecondsIn1Hour,
    MinutesInOneDay,
    MinutesInOneHour,
    DaysInOneWeek,
    HoursInOneDay,
    MonthInOneYear,
    AllDaysOfWeek: [
        DayOfWeek.Sunday,
        DayOfWeek.Monday,
        DayOfWeek.Tuesday,
        DayOfWeek.Wednesday,
        DayOfWeek.Thursday,
        DayOfWeek.Friday,
        DayOfWeek.Saturday,
    ],
};
export default TimeConstants;
